import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskPipe } from "ngx-mask";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";

@Component({
  selector: "app-transaction-summary",
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    PipesModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskPipe,
    TranslateModule,
  ],
  templateUrl: "./transaction-summary.component.html",
  styleUrl: "./transaction-summary.component.scss",
})
export class TransactionSummaryComponent {
  @Input() transaction_info: any;
  @Input() bankAcc: any;
  @Input() form: FormGroup;

  @Output() onSubmit = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  fileUrl = environment.apiFileUrl;

  submitPayment() {
    this.onSubmit.emit(true);
  }
  cancelOrder() {
    this.onCancel.emit(true);
  }

  selectedBank(id: number) {
    this.form.patchValue({
      bank_id: id,
    });
  }
}
